<template>
  <div class="edit-admin-user pad">
    <div class="pad">
      <admin-user-form v-if="user" :user="user" @submitted="submitted" />
    </div>
  </div>
</template>

<script>
import AdminUserForm from '@/components/AdminUserForm'

export default {
  components: {
    AdminUserForm
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    userId () { return this.$route.params.id }
  },
  watch: {
    userId () { this.loadUser() }
  },
  created () {
    this.loadUser()
  },
  methods: {
    loadUser () {
      this.$api('getAdminUser', { id: this.userId })
        .then(resp => {
          this.user = resp.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    submitted () {
      setTimeout(() => this.$router.push('/admin-users'), 300)
    }
  }
}
</script>

<style>

</style>
